import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=f0814dee&scoped=true&"
import script from "./MentionList.vue?vue&type=script&lang=ts&"
export * from "./MentionList.vue?vue&type=script&lang=ts&"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=f0814dee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0814dee",
  null
  
)

export default component.exports